import { cn } from '~/lib/utils'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'
import ContactLink, {
  ContactLinkProps
} from '~/components/UI/Buttons/ContactLink/ContactLink'

export type LinkBlockProps = {
  content: {
    eyebrow: string
    buttons: Array<Button['data']>
    contactLinks?: Array<ContactLinkProps['data']>
    stacked?: boolean
    sys?: { id?: string }
  }
  alignment?: 'left' | 'centre'
  layoutColour?: string
  className?: string
}

const TertiaryLinkBlock = ({
  content,
  alignment = 'left',
  layoutColour,
  className
}: LinkBlockProps) => {
  const { eyebrow, buttons, contactLinks, stacked = false } = content

  const foregroundColour = ['ink-blue', 'mid-blue'].includes(layoutColour ?? '')
    ? 'white'
    : ['white', 'light-grey'].includes(layoutColour ?? '')
      ? 'mid-blue'
      : 'ink-blue'

  return (
    <div className={cn(className, 'sm:gap-s gap-xs flex flex-col')}>
      {eyebrow && <div className='tag'>{eyebrow}</div>}
      <div
        className={cn(
          'sm:gap-x-m sm:gap-y-s gap-x-s gap-y-xs flex flex-wrap lg:gap-x-[40px]',
          stacked ? 'flex-col' : 'flex-wrap',
          alignment === 'centre' ? 'justify-center' : 'justify-start'
        )}
      >
        {buttons?.map((link, index: Index) => (
          <TertiaryLink data={link} key={index} colour={foregroundColour} />
        ))}
        {contactLinks?.map((link, index: Index) => (
          <ContactLink data={link} key={index} colour={foregroundColour} />
        ))}
      </div>
    </div>
  )
}

export default TertiaryLinkBlock
